import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";
import { useResolvedPath } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useQuery from "../../Component/devDashboard2/common/useQuery";
import { AuthContext } from "../../context/auth-context";
import {
  fetchCustomerLlms,
  getMarkets,
  getCompMetricsForBrand,
  getBrandAttributes,
  getProductAttributes,
  getCompMetricsForProduct,
  getAllBrands,
  getCustomerEfrLlm,
  getSourcesWithAlias,
  getRealtimeActionsSource,
  getCustomerMonitoringFiletrs,
  getCustomerMonitoringDates,
  getCustomerActiveMonitoringRecords,
} from "../../services/apiService";

import CompComparisonComponent from "./Component/CompComparisonComponent";
import MultiComparisonComponent from "./Component/MultiComparisonComponent";
import {
  splitByDayAndMonth,
  splitDataObjByDayAndMonth,
  transformSourceAliasData,
} from "../../utils/helpers";

import SourceComponent from "./Component/SourceComponent";
import EmptyView from "../../Component/EmptyView/EmptyView";
import BrandProductOverview from "./Component/BrandProductOverview";

import {
  calculateAverageData,
  calculateAverageDataStructure,
  filterRecentByBrandId,
  getBrandProductOverviewData,
  getComparisonDashboardData,
  getCompBrandIndexScoreAvgObj,
  getCompetitorMetricData,
  getSecondaryCategoryIndexScoreData,
  handleInputValidation,
  indexScoreChartData,
  processSourceData,
  transformDataForAttributesSources,
} from "../../utils/monitoring-helpers";
import DashboardNav from "./common/DashboardNav";
import { fetchBrandCategories } from "../../redux/actions/brandCategoriesActions";
import { transformSourceData } from "../../utils/metric-sources";
import { useRegisterTabContext } from "../../hooks/useRegisterTabContext";

const TAB_MAPPING = {
  overview: 0,
  category: 1,
  competition: 2,
  llm: 3,
  market: 4,
  personas: 5,
  sources: 6,
};

const Dashboard = (props) => {
  const { pathname } = useResolvedPath();
  const selectedOptionShow = pathname.includes("brand-monitoring")
    ? "Company/Brand"
    : "Product";

  const [activeTab, setActiveTab] = useState("overview");
  const [value, setValue] = useState(0);
  const [inputValidation, setInputValidation] = useState({
    selectedProductItems: false,
    selectedBrandItems: false,
    selectedPersona: false,
    selectedCategory: false,
    selectedGeographyItems: false,
    selectedMarketItems: false,
    selectedLlmItems: false,
  });
  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedLlmProviders, setSelectedLlmProviders] = useState([]);
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const [selectedFrequencyItems, setSelectedFrequencyItems] = useState([
    "Daily",
  ]);

  const [brandItems, setBrandItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);

  const [personas, setPersonas] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [compCoreAttributes, setCompCoreAttributes] = useState();
  const [pastCompCoreAttributes, setPastCompCoreAttributes] = useState();
  const [compCategoryDimensions, setCompCategoryDimensions] = useState();
  const [pastCompCategoryDimensions, setCompPastCategoryDimensions] =
    useState();
  const [avgBrandIndex, setAvgBrandIndex] = useState();
  const [avgPastBrandIndex, setAvgPastBrandIndex] = useState();
  const [llmAttributes, setLlmAttributes] = useState();
  const [llmNegativeAttributes, setLlmNegativeAttributes] = useState();
  const [llmAttributesSources, setLlmAttributesSources] = useState();
  const [llmNegativeAttributesSources, setLlmNegativeAttributesSources] =
    useState();

  const [llmCompBrandIndex, setLlmCompBrandIndex] = useState([]);
  const [llmCompBrandReach, setLlmCompBrandReach] = useState([]);
  const [llmCompBrandFav, setLlmCompBrandFav] = useState([]);
  const [pastLlmCompBrandIndex, setPastLlmCompBrandIndex] = useState();

  const [secCategoryBrandIndex, setSecCategoryBrandIndex] = useState([]);
  const [secCategoryBrandReach, setSecCategoryBrandReach] = useState([]);
  const [secCategoryBrandFav, setSecCategoryBrandFav] = useState([]);
  const [pastsecCategoryBrandIndex, setPastSecCategoryBrandIndex] = useState();

  const [secondaryCategoryMetaData, setSecondaryCategoryMetaData] = useState(
    []
  );

  const [indexScoreMetaData, setIndexScoreMetaData] = useState();
  const [secCategoryIndexScoreMetaData, setSecCategoryIndexScoreMetaData] =
    useState();
  const [compIndexScoreMetaData, setCompIndexScoreMetaData] = useState();
  const [categoryDimensionSourceData, setCategoryDimensionSourceData] =
    useState();
  const [coreAttSourceData, setCoreAttSourceData] = useState();
  const [reachSourceData, setReachSourceData] = useState();
  const [sentimentSourceData, setSentimentSourceData] = useState();
  const [
    categoryDimensionRatingSourceData,
    setCategoryDimensionRatingSourceData,
  ] = useState();
  const [compPositiveAttributes, setCompPositiveAttributes] = useState();
  const [compNegativeAttributes, setCompNegativeAttributes] = useState();

  const [customerLlm, setCustomerLlm] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [geography, setGeography] = useState([]);

  const [indexScoreDataForChart, setIndexScoreDataForChart] = useState([]);

  const [positiveAttGraphData, setPositiveAttGraphData] = useState([]);
  const [negativeAttGraphData, setNegativeAttGraphData] = useState([]);
  const [pastPositiveAttGraphData, setPastPositiveAttGraphData] = useState([]);
  const [pastNegativeAttGraphData, setPastNegativeAttGraphData] = useState([]);

  const [brandDomains, setBrandDomains] = useState();
  const [brandInfoJson, setBrandInfoJson] = useState();
  const [brandProductDomains, setBrandProductDomains] = useState();
  const [brandProductInfoJson, setBrandProductInfoJson] = useState();
  const [llmDomains, setLlmDomains] = useState();
  const [geoLogo, setGeoLogo] = useState();

  const [brandCategory, setBrandCategory] = useState();
  const [productCategory, setProductCategory] = useState();

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterModalType, setFilterModalType] = useState("");
  const [isFilterQuery, setIsFilterQuery] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [initialConfig, setInitialConfig] = useState({});
  const [sourceFilter, setSourceFilter] = useState({
    value: "LLM",
    label: "Compare by LLM",
  });
  const [sourceAlias, setSourceAlias] = useState();
  const [sourceURLIds, setSourceURLIds] = useState();
  const [sourceFullUrls, setSourceFullUrls] = useState();
  const [productTaxonomyData, setProductTaxonomyData] = useState([]);
  const [selectedInputIds, setSelectedInputIds] = useState();
  const [monitoringFiletrs, setMonitoringFilters] = useState();
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDates, setAvailabelDates] = useState([]);
  const [customDateFilter, setCustomDateFilter] = useState("Recent");
  const [customDatesToDisplay, setCustomDatesToDisplay] = useState(null);

  const query = useQuery();
  let selectedBrandId = query.get("brandId");
  let productId = query.get("brandProductId");
  const selectedLlmId = query.get("llmId");
  const selectedMarketId = query.get("marketId");
  const selectedGeoId = query.get("geotId");

  const selectedLlmName = query.get("llmName");
  const selectedMarketName = query.get("marketName");
  const selectedGeoName = query.get("geoName");
  const selectedPersonaName = query.get("personaName");
  const selectedCategoryName = query.get("categorytName");

  const frequency = query.get("dateRange");

  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] = useState(
    frequency || "Current"
  );

  const dispatch = useDispatch();
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);
  const brandCategories = useSelector((state) => state.brandCategories);

  const { user } = useContext(AuthContext);
  const isCompanyUser = user?.user_role?.role?.name === "Company user";
  const customerId = user?.customer_id || 0;

  const handleFilterChange = (option) => {
    if (option.value === "LLM") {
      const llms = dbLlms.map((obj) => obj?.name);
      setSelectedLlmItems(llms);
      setSelectedPersona((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInPersona = personas?.some((p) => p.name === selectedName);
        const newName = existsInPersona ? selectedName : "General Persona";
        return [newName];
      });

      // setSelectedCategory([categories?.[0]?.name]);
      setSelectedCategory((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInCategory = categories?.some(
          (p) => p.name === selectedName
        );
        const newName = existsInCategory ? selectedName : categories?.[0]?.name;
        return [newName];
      });
      setSelectedCategoryIds((prevSelected) => {
        const selectedId = prevSelected?.[0];
        const existsInCategoryId = categories?.some((p) => p.id === selectedId);
        const newId = existsInCategoryId ? selectedId : categories?.[0]?.id;
        return [newId];
      });
    } else if (option.value === "CATEGORY") {
      setSelectedPersona((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInPersona = personas?.some((p) => p.name === selectedName);
        const newName = existsInPersona ? selectedName : "General Persona";
        return [newName];
      });
      // setSelectedLlmItems(["gpt-4o"]);
      setSelectedLlmItems((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInLlms = dbLlms?.some((p) => p.name === selectedName);
        const newName = existsInLlms ? selectedName : "gpt-4o";
        // Update provider based on selected LLM and get all LLMs from that provider
        const selectedLlm = dbLlms?.find(llm => llm.name === newName);
        if (selectedLlm) {
          const provider = selectedLlm.llm_provider || "Other";
          setSelectedLlmProviders([provider]);

          // Get all LLMs from the same provider
          const allLlmsFromProvider = dbLlms
            ?.filter(llm => (llm.llm_provider || "Other") === provider)
            .map(llm => llm.name) || [];
          return allLlmsFromProvider;
        }
        return [newName];
      });
      const selectedNames = categories?.map((item) => item.name);
      const selectedIds = categories?.map((item) => item.id);
      setSelectedCategory(selectedNames);
      setSelectedCategoryIds(selectedIds);
    } else {
      setSelectedPersona(personas?.map((obj) => obj?.name));
      // setSelectedLlmItems(["gpt-4o"]);
      setSelectedLlmItems((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInLlms = dbLlms?.some((p) => p.name === selectedName);
        const newName = existsInLlms ? selectedName : "gpt-4o";
        // Update provider based on selected LLM and get all LLMs from that provider
        const selectedLlm = dbLlms?.find(llm => llm.name === newName);
        if (selectedLlm) {
          const provider = selectedLlm.llm_provider || "Other";
          setSelectedLlmProviders([provider]);

          // Get all LLMs from the same provider
          const allLlmsFromProvider = dbLlms
            ?.filter(llm => (llm.llm_provider || "Other") === provider)
            .map(llm => llm.name) || [];
          return allLlmsFromProvider;
        }
        return [newName];
      });
      // setSelectedCategory([categories?.[0]?.name]);
      setSelectedCategory((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInCategory = categories?.some(
          (p) => p.name === selectedName
        );
        const newName = existsInCategory ? selectedName : categories?.[0]?.name;
        return [newName];
      });
      setSelectedCategoryIds((prevSelected) => {
        const selectedId = prevSelected?.[0];
        const existsInCategoryId = categories?.some((p) => p.id === selectedId);
        const newId = existsInCategoryId ? selectedId : categories?.[0]?.id;
        return [newId];
      });
    }
    setSourceFilter(option);
  };

  // useEffect(() => {
  //   if (selectedSubFrequencyItems === "Custom") {
  //     const customerLlmIds = getCustomerLlmInputIds();
  //     const { brandId, productId, personaId } = getInputIds();
  //     updateMonitoringDateList(brandId, productId, selectedCategoryIds, customerLlmIds, personaId, selectedOptionShow)
  //   }
  // }, [selectedSubFrequencyItems])

  const shouldShowLoader = () => {
    const hasRequiredSelections =
      (selectedOptionShow === "Product"
        ? inputValidation.selectedProductItems
        : inputValidation.selectedBrandItems) &&
      inputValidation.selectedPersona &&
      inputValidation.selectedGeographyItems &&
      inputValidation.selectedMarketItems &&
      inputValidation.selectedCategory &&
      inputValidation.selectedLlmItems;

    return (!showData && !isDone && hasRequiredSelections) || isFirstTime;
  };

  useEffect(() => {
    // setShowData(false);
    // setIsDone(false);
    const handler = setTimeout(async () => {
      if (selectedSubFrequencyItems === "Custom") {
        const customerLlmIds = getCustomerLlmInputIds();
        const { brandId, productId, personaId } = getInputIds();
        const dates = await updateMonitoringDateList(
          brandId,
          productId,
          selectedCategoryIds,
          customerLlmIds,
          personaId,
          selectedOptionShow
        );
        if (!dates || dates.length === 0) {
          toast.warn("Monitoring Run dates are not Available!", {
            autoClose: 1100,
          });
          setSelectedSubFrequencyItems("Current");
          return;
        }
        if (JSON.stringify(availableDates) === JSON.stringify(dates)) {
          handleClickShow();
        } else {
          setAvailabelDates(dates);
        }
      } else {
        if (
          selectedPersona.length &&
          (selectedBrandItems.length || selectedProductItems.length) &&
          !isFirstTime
        ) {
          handleClickShow();
          setIsFilterQuery(false);
        }
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [
    selectedPersona,
    selectedGeographyItems,
    selectedMarketItems,
    selectedLlmItems,
    selectedSubFrequencyItems,
    customDateFilter,
  ]);

  const updateMonitoringDateList = async (
    brandId,
    productId,
    categoryIds,
    llmIds,
    personaIds,
    type
  ) => {
    const payload = {
      productId,
      categoryIds,
      llmIds,
      personaIds,
      brandId,
      type,
      customerId,
      isCompanyUser,
    };
    const dates = await getCustomerMonitoringDates(customerId, payload);
    // setAvailabelDates(selectedOptionShow === 'Product' ? dates?.productDates : dates?.brandDates)
    return selectedOptionShow === "Product"
      ? dates?.productDates
      : dates?.brandDates;
  };

  const updateFiltersState = (tab, llms, geo, markets, personas) => {
    // setSelectedGeographyItems(prevSelected => {
    //   const selectedName = prevSelected?.[0];
    //   if (geography?.some(g => g.name === selectedName)) {
    //     return [selectedName];
    //   }
    //   return [geo];
    // });
    const isLlmTab =
      tab === "llm" || (tab === "sources" && sourceFilter?.value === "LLM");
    setSelectedLlmItems((prevSelected) => {
      const selectedName = prevSelected?.[0];
      const existsInLlms = llms?.some((p) => p.name === selectedName);
      const newName = existsInLlms ? selectedName : "gpt-4o";

      if (isLlmTab) {
        // For LLM tab, select all providers and all LLMs
        const allProviders = [...new Set(llms.map(llm => llm.llm_provider || "Other"))];
        setSelectedLlmProviders(allProviders);
        return llms.map((obj) => obj?.name);
      } else {
        // For non-LLM tabs, get all LLMs from the same provider as the selected LLM
        const selectedLlm = llms?.find(llm => llm.name === newName);
        if (selectedLlm) {
          const provider = selectedLlm.llm_provider || "Other";
          setSelectedLlmProviders([provider]);

          // Get all LLMs from the same provider
          const allLlmsFromProvider = llms
            ?.filter(llm => (llm.llm_provider || "Other") === provider)
            .map(llm => llm.name) || [];
          return allLlmsFromProvider;
        }
        return [newName];
      }
    });
    // setSelectedLlmItems(isLlmTab ? llms.map((obj) => obj?.name) : ["gpt-4o"]);

    const isPersonaTab =
      tab === "personas" ||
      (tab === "sources" && sourceFilter?.value === "PERSONA");
    setSelectedPersona((prevSelected) => {
      const selectedName = prevSelected?.[0];
      const existsInPersona = personas?.some((p) => p.name === selectedName);
      const newName = existsInPersona ? selectedName : "General Persona";
      return isPersonaTab ? personas.map((obj) => obj?.name) : [newName];
    });

    const isMarketTab = tab === "market";
    // setSelectedMarketItems(
    //   isMarketTab ? markets.map((obj) => obj?.name) : ["General Market"]
    // );

    setSelectedMarketItems((prevSelected) => {
      const selectedName = prevSelected?.[0];
      const existsInMarket = markets?.some((p) => p.name === selectedName);
      const newName = existsInMarket ? selectedName : "General Market";
      return [newName];
    });

    setSelectedGeographyItems((prevSelected) => {
      const selectedName = prevSelected?.[0];
      const existsInMarket = geography?.some((p) => p.name === selectedName);
      const newName = existsInMarket ? selectedName : geo;
      return isMarketTab ? geography?.map((obj) => obj?.name) : [newName];
    });
  };

  const handleTabClick = (tab) => {
    const isLlmTab = tab === "llm" || tab === "sources";
    const isCategoryTab = tab === "category";
    const isPersonaTab = tab === "personas";
    const isMarketTab = tab === "market";

    setSourceFilter(
      isLlmTab
        ? { value: "LLM", label: "Compare by LLM" }
        : isCategoryTab
          ? { value: "CATEGORY", label: "Compare by LLM" }
          : isPersonaTab
            ? { value: "PERSONA", label: "Compare by PERSONA" }
            : null
    );

    if (isCategoryTab) {
      setSelectedCategory(categories.map((obj) => obj?.name));
      setSelectedCategoryIds(categories.map((obj) => obj?.id));
    } else {
      setSelectedCategory((prevSelected) => {
        const selectedName = prevSelected?.[0];
        const existsInCategory = categories?.some(
          (p) => p.name === selectedName
        );
        const newName = existsInCategory ? selectedName : categories?.[0]?.name;
        return [newName];
      });
      setSelectedCategoryIds((prevSelected) => {
        const selectedId = prevSelected?.[0];
        const existsInCategoryId = categories?.some((p) => p.id === selectedId);
        const newId = existsInCategoryId ? selectedId : categories?.[0]?.id;
        return [newId];
      });
    }

    // Handle market tab - set multiple geos and single market

    if (isMarketTab) {
      // Multiple geos available - select all geos and single market
      setSelectedGeographyItems(geography.map((obj) => obj?.name));
      const generalMarket = markets?.find((m) => m.name === "General Market");
      setSelectedMarketItems(
        generalMarket ? [generalMarket.name] : [markets?.[0]?.name]
      );
    }

    setShowData(false);
    setActiveTab(tab);
    setValue(TAB_MAPPING[tab]);
  };

  useEffect(() => {
    setInputValidation({
      selectedProductItems: !!selectedProductItems.length,
      selectedBrandItems: !!selectedBrandItems.length,
      selectedPersona: !!selectedPersona.length,
      selectedCategory: !!selectedCategory.length,
      selectedGeographyItems: !!selectedGeographyItems.length,
      selectedMarketItems: !!selectedMarketItems.length,
      selectedLlmItems: selectedLlmItems?.some((v) => v !== undefined),
    });
  }, [
    selectedProductItems,
    selectedBrandItems,
    selectedPersona,
    selectedGeographyItems,
    selectedMarketItems,
    selectedLlmItems,
    selectedCategory,
  ]);

  const getRecentActiveLlms = async () => {
    const caseData = await getCustomerActiveMonitoringRecords(customerId);
    const brandLlms = caseData?.brand?.map((item) => item?.llmname) || [];
    const productLlms = caseData?.product?.map((item) => item?.llmname) || [];
    return {
      brandLlms: [...new Set([...brandLlms])],
      productLlms: [...new Set([...productLlms])],
    };
  };

  useEffect(() => {
    async function fetchData() {
      const allBrands = await getAllBrands();
      const activeLlms = await getRecentActiveLlms();
      const {
        llms: allLlms,
        brand: brandInfo,
        brandProducts: brandProductInfo,
        geographies: geoCodes,
      } = allBrands?.data || {};

      const createDomainMap = (data, key = "domain_url") =>
        data?.reduce((acc, item) => {
          acc[item.name] = item[key];
          return acc;
        }, {});

      const createJsonMap = (data, key = "resp_json") =>
        data?.reduce((acc, item) => {
          acc[item.name] = item[key];
          return acc;
        }, {});
      setBrandInfoJson(createJsonMap(brandInfo));
      setBrandDomains(createDomainMap(brandInfo));
      setBrandProductInfoJson(createJsonMap(brandProductInfo));
      setBrandProductDomains(createDomainMap(brandProductInfo));
      setLlmDomains(createDomainMap(allLlms));
      setGeoLogo(createDomainMap(geoCodes, "country_code"));

      const selectedBrandCustomerId =
        query.get("brandCustomerId") || customerId;
      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);

      setCustomerLlm(customerSpecificLlms?.data);
      const inputFilters = await getCustomerMonitoringFiletrs(customerId);

      // Deep copy to avoid mutation if needed (e.g., structuredClone or JSON approach)
      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };

      // Apply brand filter if selected
      if (selectedBrandId) {
        filters.brands = filters.brands.filter(
          (item) => item?.customer_brand_id === Number(selectedBrandId)
        );
      }

      // Apply product filter if selected
      if (productId) {
        filters.products = filters.products.filter(
          (item) => item?.customer_brand_product_id === Number(productId)
        );
      }

      setMonitoringFilters(filters);
      // setAvailabelDates(selectedOptionShow === 'Product' ? inputFilters?.productDates : inputFilters?.brandDates)

      if (selectedOptionShow === "Company/Brand") {
        const llms = filters?.brands?.[0]?.categories?.[0]?.llms;
        // const gpt4oObj = llms?.find((obj) => obj?.name === "gpt-4o");
        const gpt4oObj = llms?.find((obj) =>
          activeLlms?.brandLlms?.includes(obj?.name)
        );
        const defaultLlm = gpt4oObj || llms?.[0];
        let llmFromQuery = llms.filter((obj) => obj?.id === selectedLlmId);
        llmFromQuery =
          llmFromQuery && llmFromQuery.length !== 0
            ? llmFromQuery[0]?.name
            : selectedLlmName || defaultLlm.name;

        const markets = filters?.brands?.[0]?.categories?.[0]?.markets;
        let marketFromQuery = markets.filter(
          (obj) => obj?.id === selectedMarketId
        );
        marketFromQuery =
          marketFromQuery && marketFromQuery.length !== 0
            ? marketFromQuery[0]?.name
            : selectedMarketName || markets?.[0]?.name;

        const geography = filters?.brands?.[0]?.categories?.[0]?.geographies;
        const defaultGeography = filters?.brands?.[0]?.customer_brand_geo;
        let geoFromQuery = geography.filter((obj) => obj?.id === selectedGeoId);
        geoFromQuery =
          geoFromQuery && geoFromQuery.length !== 0
            ? geoFromQuery[0]?.name
            : selectedGeoName ||
              geography?.some((obj) => obj.name === defaultGeography?.name)
              ? defaultGeography?.name
              : geography?.[0]?.name;

        const persona = filters?.brands?.[0]?.categories?.[0]?.personas;
        const category = filters?.brands?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });

        const globalLlmId =
          selectedLlmId ||
          llms?.filter((obj) => obj?.name === selectedLlmName)?.[0]?.id ||
          defaultLlm.id;
        const marketId =
          selectedMarketId ||
          markets?.filter((obj) => obj?.name === selectedMarketName)?.[0]?.id ||
          markets?.[0]?.id;
        const geoId =
          selectedGeoId ||
            geography?.filter((obj) => obj?.name === selectedGeoName)?.[0]?.id ||
            geography?.some((obj) => obj.name === defaultGeography?.name)
            ? defaultGeography?.id
            : geography?.[0]?.id;
        const llmId = customerSpecificLlms?.data?.filter(
          (item) =>
            item?.llm_id === globalLlmId &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        )[0]?.id;
        const brandName = filters?.brands?.[0]?.brand_name;
        const generalPersona = persona?.find(
          (p) => p.name === "General Persona"
        );
        const brandId = filters?.brands?.[0]?.customer_brand_id || null;
        // const personaId = [persona?.filter((obj) => obj?.name === selectedPersonaName)?.[0]?.id || persona?.[0]?.id];
        const personaId = [
          persona?.find((p) => p.name === selectedPersonaName)?.id ||
          generalPersona?.id ||
          persona?.[0]?.id,
        ];
        const categoryIds =
          [
            category?.filter((obj) => obj?.name === selectedCategoryName)?.[0]
              ?.id || category?.[0]?.id,
          ] || null;

        setDbLlms(llms);
        setMarkets(markets);
        setGeography(geography);

        setSelectedBrandItems([filters?.brands?.[0]?.brand_name]);
        // setSelectedPersona([selectedPersonaName || persona?.[0]?.name]);
        setSelectedPersona([
          selectedPersonaName || generalPersona?.name || persona?.[0]?.name,
        ]);

        // Set the provider for the selected LLM and get all LLMs from that provider
        const selectedLlm = llms?.find(llm => llm.name === llmFromQuery);
        let allLlmsFromProvider = [llmFromQuery];

        if (selectedLlm) {
          const provider = selectedLlm.llm_provider || "Other";
          setSelectedLlmProviders([provider]);

          // Get all LLMs from the same provider
          allLlmsFromProvider = llms
            ?.filter(llm => (llm.llm_provider || "Other") === provider)
            .map(llm => llm.name) || [llmFromQuery];
          setSelectedLlmItems(allLlmsFromProvider);
        } else {
          setSelectedLlmItems([llmFromQuery]);
        }

        // Calculate customer LLM IDs for all LLMs from the provider (for initial API call)
        const allLlmIds = llms
          .filter((item) => allLlmsFromProvider.includes(item?.name))
          .map((obj) => obj?.id);

        const initialCustomerLlmIds = customerSpecificLlms?.data?.filter(
          (item) =>
            allLlmIds.includes(item?.llm_id) &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        ).map((obj) => obj?.id) || [llmId];

        setSelectedMarketItems([marketFromQuery]);
        setSelectedGeographyItems([geoFromQuery]);
        setBrandItems(
          filters?.brands?.map((item) => {
            return { id: item?.customer_brand_id, name: item?.brand_name };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([selectedCategoryName || category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);

        // Store initial customer LLM IDs for immediate use
        window.__initialCustomerLlmIds = initialCustomerLlmIds;

        // initial data load
        handleDashboardInitialData(
          brandId,
          undefined,
          llmId,
          personaId,
          brandName,
          undefined,
          categoryIds
        );
        // await updateMonitoringDateList(brandId, undefined, categoryIds, [llmId], personaId, selectedOptionShow)
      }

      if (selectedOptionShow === "Product") {
        const defaultGeography = filters?.products?.[0]?.customer_product_geo;
        const geography = filters?.products?.[0]?.categories?.[0]?.geographies;
        const markets = filters?.products?.[0]?.categories?.[0]?.markets;
        const persona = filters?.products?.[0]?.categories?.[0]?.personas;
        const llms = filters?.products?.[0]?.categories?.[0]?.llms;
        const category = filters?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const generalPersona = persona?.find(
          (p) => p.name === "General Persona"
        );
        const categoryIds = [category?.[0]?.id] || null;

        const brandProductId =
          filters?.products?.[0]?.customer_brand_product_id || null;
        const personaId = [generalPersona?.id || persona?.[0]?.id];
        const globalLlmId = selectedLlmId || 1;
        const marketId = selectedMarketId || markets?.[0]?.id;
        const geoId =
          selectedGeoId ||
            geography?.some((obj) => obj.name === defaultGeography?.name)
            ? defaultGeography?.id
            : geography?.[0]?.id;
        const llmId = customerSpecificLlms?.data?.filter(
          (item) =>
            item?.llm_id === globalLlmId &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        )[0]?.id;

        const productName = filters?.products?.[0]?.product_name;
        // const generalPersona = persona?.find(p => p.name === "General Persona");

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([filters?.products?.[0]?.product_name]);
        // setSelectedPersona([persona?.[0]?.name]);
        setSelectedPersona([
          generalPersona?.name || persona?.[0]?.name
        ]);

        // Set provider for gpt-4o and get all LLMs from that provider
        const gpt4oLlm = llms?.find(llm => llm.name === 'gpt-4o');
        let allLlmsFromProvider = ['gpt-4o'];

        if (gpt4oLlm) {
          const provider = gpt4oLlm.llm_provider || "Other";
          setSelectedLlmProviders([provider]);

          // Get all LLMs from the same provider
          allLlmsFromProvider = llms
            ?.filter(llm => (llm.llm_provider || "Other") === provider)
            .map(llm => llm.name) || ['gpt-4o'];
          setSelectedLlmItems(allLlmsFromProvider);
        } else {
          setSelectedLlmItems(['gpt-4o']);
        }

        // Calculate customer LLM IDs for all LLMs from the provider (for initial API call)
        const allLlmIds = llms
          .filter((item) => allLlmsFromProvider.includes(item?.name))
          .map((obj) => obj?.id);

        const initialCustomerLlmIds = customerSpecificLlms?.data?.filter(
          (item) =>
            allLlmIds.includes(item?.llm_id) &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        ).map((obj) => obj?.id) || [llmId];

        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([
          geography?.some((obj) => obj.name === defaultGeography?.name)
            ? defaultGeography?.name
            : geography?.[0]?.name,
        ]);
        setProductItems(
          filters?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);

        // Store initial customer LLM IDs for immediate use
        window.__initialCustomerLlmIds = initialCustomerLlmIds;

        handleDashboardInitialData(
          undefined,
          brandProductId,
          llmId,
          personaId,
          undefined,
          productName,
          categoryIds
        );
        // await updateMonitoringDateList(undefined, brandProductId, categoryIds, [llmId], personaId, selectedOptionShow)
      }

      if (brandCategories?.data && brandCategories?.data.length === 0) {
        dispatch(fetchBrandCategories(customerId));
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (
        !isFirstTime &&
        !isFilterQuery &&
        selectedProductItems &&
        selectedProductItems.length > 0
      ) {
        if (selectedOptionShow === "Product") {
          const defaultGeography = monitoringFiletrs?.products?.filter((item) =>
            selectedProductItems.includes(item?.product_name)
          )?.[0]?.customer_product_geo;
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;
          const category = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems?.includes(item?.product_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;
          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          // setSelectedLlmItems(['gpt-4o']);
          // setSelectedMarketItems([markets?.[0]?.name]);
          setSelectedLlmItems((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInLlms = llms?.some((p) => p.name === selectedName);
            const newName = existsInLlms ? selectedName : "gpt-4o";
            // Update provider based on selected LLM and get all LLMs from that provider
            const selectedLlm = llms?.find(llm => llm.name === newName);
            if (selectedLlm) {
              const provider = selectedLlm.llm_provider || "Other";
              setSelectedLlmProviders([provider]);

              // Get all LLMs from the same provider
              const allLlmsFromProvider = llms
                ?.filter(llm => (llm.llm_provider || "Other") === provider)
                .map(llm => llm.name) || [];
              return allLlmsFromProvider;
            }
            return [newName]
          });
          setSelectedMarketItems((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInMarkets = markets?.some(
              (p) => p.name === selectedName
            );
            const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
            return [newName];
          });
          // setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
          setSelectedGeographyItems((prevSelected) => {
            const selectedName = prevSelected?.[0];

            if (geography?.some((g) => g.name === selectedName)) {
              return [selectedName];
            }

            const fallbackName = geography?.some(
              (g) => g.name === defaultGeography?.name
            )
              ? defaultGeography?.name
              : geography?.[0]?.name;

            return [fallbackName];
          });

          setSelectedPersona((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInPersona = persona?.some(
              (p) => p.name === selectedName
            );
            const newName = existsInPersona ? selectedName : persona?.[0]?.name;
            return [newName];
          });

          const isCategoryTab = activeTab === "category";
          if (isCategoryTab) {
            setSelectedCategory(category.map((obj) => obj?.name));
            setSelectedCategoryIds(category.map((obj) => obj?.id));
          } else {
            setSelectedCategory((prevSelected) => {
              const selectedName = prevSelected?.[0];
              const existsInCategory = category?.some(
                (p) => p.name === selectedName
              );
              const newName = existsInCategory
                ? selectedName
                : category?.[0]?.name;
              return [newName];
            });
            setSelectedCategoryIds((prevSelected) => {
              const selectedId = prevSelected?.[0];
              const existsInCategoryId = category?.some(
                (p) => p.id === selectedId
              );
              const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
              return [newId];
            });
          }
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedProductItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (
        !isFirstTime &&
        !isFilterQuery &&
        selectedBrandItems &&
        selectedBrandItems.length > 0
      ) {
        if (selectedOptionShow === "Company/Brand") {
          const defaultGeography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.customer_brand_geo;
          const geography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.markets;
          const persona = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.personas;
          const llms = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.categories?.[0]?.llms;
          const category = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems?.includes(item?.brand_name)
            )?.[0]
            ?.categories?.map((item) => {
              return { id: item?.categoryId, name: item?.categoryName };
            });
          const categoryIds = [category?.[0]?.id] || null;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          setCategories(category);
          // setSelectedLlmItems(['gpt-4o']);
          // setSelectedMarketItems([markets?.[0]?.name]);
          // setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
          setSelectedLlmItems((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInLlms = llms?.some((p) => p.name === selectedName);
            const newName = existsInLlms ? selectedName : "gpt-4o";
            // Update provider based on selected LLM and get all LLMs from that provider
            const selectedLlm = llms?.find(llm => llm.name === newName);
            if (selectedLlm) {
              const provider = selectedLlm.llm_provider || "Other";
              setSelectedLlmProviders([provider]);

              // Get all LLMs from the same provider
              const allLlmsFromProvider = llms
                ?.filter(llm => (llm.llm_provider || "Other") === provider)
                .map(llm => llm.name) || [];
              return allLlmsFromProvider;
            }
            return [newName]
          });
          setSelectedMarketItems((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInMarkets = markets?.some(
              (p) => p.name === selectedName
            );
            const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
            return [newName];
          });
          setSelectedGeographyItems((prevSelected) => {
            const selectedName = prevSelected?.[0];

            if (geography?.some((g) => g.name === selectedName)) {
              return [selectedName];
            }

            const fallbackName = geography?.some(
              (g) => g.name === defaultGeography?.name
            )
              ? defaultGeography?.name
              : geography?.[0]?.name;

            return [fallbackName];
          });

          setSelectedPersona((prevSelected) => {
            const selectedName = prevSelected?.[0];
            const existsInPersona = persona?.some(
              (p) => p.name === selectedName
            );
            const newName = existsInPersona ? selectedName : persona?.[0]?.name;
            return [newName];
          });

          // setSelectedCategory([category?.[0]?.name]);
          // setSelectedCategoryIds(categoryIds);

          const isCategoryTab = activeTab === "category";
          if (isCategoryTab) {
            setSelectedCategory(category.map((obj) => obj?.name));
            setSelectedCategoryIds(category.map((obj) => obj?.id));
          } else {
            setSelectedCategory((prevSelected) => {
              const selectedName = prevSelected?.[0];
              const existsInCategory = category?.some(
                (p) => p.name === selectedName
              );
              const newName = existsInCategory
                ? selectedName
                : category?.[0]?.name;
              return [newName];
            });
            setSelectedCategoryIds((prevSelected) => {
              const selectedId = prevSelected?.[0];
              const existsInCategoryId = category?.some(
                (p) => p.id === selectedId
              );
              const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
              return [newId];
            });
          }
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedBrandItems]);

  useEffect(() => {
    async function fetchCustomerLlmsData() {
      if (
        !isFirstTime &&
        !isFilterQuery &&
        selectedCategory &&
        selectedCategory.length > 0
      ) {
        if (
          selectedProductItems?.length !== 0 &&
          selectedOptionShow === "Product"
        ) {
          const defaultGeography = monitoringFiletrs?.products?.filter((item) =>
            selectedProductItems.includes(item?.product_name)
          )?.[0]?.customer_product_geo;
          const geography = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.products
            ?.filter((item) =>
              selectedProductItems.includes(item?.product_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          const defaultGeo = geography?.some(
            (obj) => obj.name === defaultGeography?.name
          )
            ? defaultGeography?.name
            : geography?.[0]?.name;
          updateFiltersState(activeTab, llms, defaultGeo, markets, persona);
        }

        if (
          selectedBrandItems?.length !== 0 &&
          selectedOptionShow === "Company/Brand"
        ) {
          const defaultGeography = monitoringFiletrs?.brands?.filter((item) =>
            selectedBrandItems.includes(item?.brand_name)
          )?.[0]?.customer_brand_geo;
          const geography = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.geographies;
          const markets = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.markets;
          const persona = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.personas;
          const llms = monitoringFiletrs?.brands
            ?.filter((item) =>
              selectedBrandItems.includes(item?.brand_name)
            )?.[0]
            ?.categories?.filter((item) =>
              selectedCategory?.includes(item?.categoryName)
            )?.[0]?.llms;

          setDbLlms(llms);
          setGeography(geography);
          setMarkets(markets);
          setPersonas(persona);
          const defaultGeo = geography?.some(
            (obj) => obj.name === defaultGeography?.name
          )
            ? defaultGeography?.name
            : geography?.[0]?.name;
          updateFiltersState(activeTab, llms, defaultGeo, markets, persona);
        }
      }
    }

    fetchCustomerLlmsData();
  }, [selectedCategory]);

  const handleLlmCheckChange = (selected) => {
    if (shouldShowLoader()) return;

    // Handle both single object (when allowMultipleProviders=false) and array (when allowMultipleProviders=true)
    const selectedArray = Array.isArray(selected) ? selected : (selected ? [selected] : []);

    // Extract provider names
    const selectedProviderValues = selectedArray.map((option) => option?.value);

    // For LLM tab (value === 3) OR sources tab with LLM filter (value === 6), allow multiple providers
    // For other tabs, only keep the last selected provider
    const isLlmTab = value === 3 || (value === 6 && sourceFilter?.value === "LLM");
    const providersToUse = isLlmTab
      ? selectedProviderValues
      : selectedProviderValues.length > 0
        ? [selectedProviderValues.at(-1)]
        : [];

    // Extract all LLM names from selected providers
    const allLlmNames = [];
    selectedArray.forEach((providerOption) => {
      if (providersToUse.includes(providerOption.value)) {
        providerOption.llms?.forEach((llm) => {
          allLlmNames.push(llm.name);
        });
      }
    });

    setSelectedLlmProviders(providersToUse);
    setSelectedLlmItems(allLlmNames);
  };

  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  const handleMarketCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    let selectedValues = selected?.map((option) => option?.name) || [];
    const isMarketTab = value === 4;

    if (isMarketTab && selectedValues.length > 1) {
      // Market tab: if multiple markets selected, switch geography to single
      const generalLocation = geography?.find(
        (g) => g.name === "General Location"
      );
      const geoToSelect = generalLocation
        ? [generalLocation.name]
        : [geography?.[0]?.name];
      setSelectedGeographyItems(geoToSelect);
    } else if (!isMarketTab) {
      // Other tabs: only allow single market selection
      let lastIndex = selectedValues.length - 1;
      selectedValues = selectedValues?.filter(
        (item, index) => index === lastIndex
      );
    }

    setSelectedMarketItems(selectedValues || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    if (shouldShowLoader()) return;
    let selectedValues = selected?.map((option) => option?.name) || [];
    const isMarketTab = value === 4;

    if (isMarketTab && selectedValues.length > 1) {
      // Market tab: if multiple geos selected, switch market to single
      const generalMarket = markets?.find((m) => m.name === "General Market");
      const marketToSelect = generalMarket
        ? [generalMarket.name]
        : [markets?.[0]?.name];
      setSelectedMarketItems(marketToSelect);
    } else if (!isMarketTab) {
      // Other tabs: only allow single geography selection
      let lastIndex = selectedValues.length - 1;
      selectedValues = selectedValues?.filter(
        (item, index) => index === lastIndex
      );
    }
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems(selectedValues || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleProductCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setShowData(false);
    setIsDone(false);
    setSelectedProductItems(selectedValues || []);
  };

  const handleBrandCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    setShowData(false);
    setIsDone(false);
    setSelectedBrandItems(selectedValues || []);
  };

  const handlePersonaCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    const selectedValues = selected?.map((option) => option?.name);
    if (value === 5 || sourceFilter?.value === "PERSONA") {
      setSelectedPersona(selectedValues || []);
    } else {
      let lastIndex = selectedValues.length - 1;
      const lastSelectedValue = selectedValues?.filter(
        (item, index) => index === lastIndex
      );
      setSelectedPersona(lastSelectedValue || []);
    }
  };

  const handleCategoryCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    if (!selected || selected.length === 0) {
      setSelectedCategory([]);
      setSelectedCategoryIds([]);
      return;
    }

    if (value === 1 || sourceFilter?.value === "CATEGORY") {
      const selectedNames = selected.map((item) => item.name);
      const selectedIds = selected.map((item) => item.id);
      setSelectedCategory(selectedNames);
      setSelectedCategoryIds(selectedIds);
    } else {
      const lastSelected = selected[selected.length - 1];
      setSelectedCategory([lastSelected.name]);
      setSelectedCategoryIds([lastSelected.id]);
    }
  };

  const getInputIds = () => {
    const brandId =
      brandItems?.filter((item) => item?.name === selectedBrandItems[0])[0]
        ?.id || null;

    const productId =
      productItems?.filter((item) => item?.name === selectedProductItems[0])[0]
        ?.id || null;

    const brandIds = brandItems
      ?.filter((item) => selectedBrandItems.includes(item?.name))
      .map((obj) => obj?.id);

    const productIds = productItems
      ?.filter((item) => selectedProductItems.includes(item?.name))
      .map((obj) => obj?.id);

    const globalLlmId = dbLlms?.filter(
      (item) => item?.name === selectedLlmItems[0]
    )[0]?.id;
    const marketId = markets?.filter(
      (item) => item?.name === selectedMarketItems[0]
    )[0]?.id;

    const geoId = geography?.filter(
      (item) => item?.name === selectedGeographyItems[0]
    )[0]?.id;

    const llmId = customerLlm?.filter(
      (item) =>
        item?.llm_id === globalLlmId &&
        item?.market_id === marketId &&
        item?.geography_id === geoId
    )[0]?.id;
    const personaId = personas
      ?.filter((item) => selectedPersona.includes(item?.name))
      .map((obj) => obj?.id);

    return {
      brandId,
      brandIds,
      productId,
      productIds,
      globalLlmId,
      llmId,
      personaId,
    };
  };

  const handleDashboardInitialData = async (
    brandId,
    productId,
    llmId,
    personaId,
    brandName,
    productName,
    categoryIds
  ) => {
    await getCompDashboardDataFromDB(
      brandId,
      productId,
      llmId,
      personaId,
      true,
      brandName,
      productName,
      undefined,
      undefined,
      undefined,
      categoryIds
    );
    setIsFirstTime(false);
  };

  const handleClickShow = async (isMetaRefresh) => {
    const error = handleInputValidation(
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      selectedPersona,
      selectedFrequencyItems,
      value,
      selectedSubFrequencyItems,
      selectedLlmItems,
      selectedGeographyItems,
      selectedMarketItems,
      selectedCategory
    );

    if (error) {
      toast.error(error, {
        autoClose: 700,
      });
      return;
    }
    const { brandId, brandIds, productId, productIds, llmId, personaId } =
      getInputIds();
    if (value === 0) {
      await getCompDashboardDataFromDB(
        brandId,
        productId,
        llmId,
        personaId,
        false,
        undefined,
        undefined,
        undefined,
        brandIds,
        productIds,
        undefined,
        isMetaRefresh
      );
    } else if (value === 2) {
      await getCompDashboardDataFromDB(
        brandId,
        productId,
        llmId,
        personaId,
        false
      );
    } else {
      await getLlmComparisonDashboardDataFromDB(
        brandId,
        productId,
        llmId,
        personaId,
        false
      );
    }
  };

  const getCompetitorIndexScores = (
    result,
    brandName,
    productName,
    realPastDate
  ) => {
    if (
      typeof result?.indexScoreDataForChart === "object" &&
      result?.indexScoreDataForChart !== null &&
      !Array.isArray(result?.indexScoreDataForChart) &&
      Object.keys(result?.indexScoreDataForChart).length > 0
    ) {
      const brandIndexChartArray = indexScoreChartData(
        result?.indexScoreDataForChart,
        "avg_brand_index_score",
        brandName,
        productName,
        selectedOptionShow,
        selectedProductItems,
        selectedBrandItems
      );

      setIndexScoreDataForChart(brandIndexChartArray);
    }
    if (result?.brandIndexcumulativeData) {
      const splittedData = splitDataObjByDayAndMonth(
        realPastDate?.day,
        realPastDate?.month,
        realPastDate?.year,
        result?.brandIndexcumulativeData,
        selectedSubFrequencyItems === "Current",
        selectedSubFrequencyItems === "Custom"
      );

      let currentAvgData = splittedData?.filteredData;
      let pastAvgData = splittedData?.remainingData;

      currentAvgData = getCompBrandIndexScoreAvgObj(
        currentAvgData,
        brandName,
        productName,
        selectedOptionShow,
        selectedBrandItems,
        selectedProductItems
      );
      pastAvgData = getCompBrandIndexScoreAvgObj(
        pastAvgData,
        brandName,
        productName,
        selectedOptionShow,
        selectedBrandItems,
        selectedProductItems
      );
      setAvgBrandIndex(currentAvgData);
      setAvgPastBrandIndex(pastAvgData);
    }
  };

  const getSecCategoryIndexScoreMetaData = async (result) => {
    let indexScoreMeta = result?.secondaryCategoryMeta || [];

    const currentBrandProduct =
      selectedOptionShow === "Product"
        ? selectedProductItems?.[0]
        : selectedBrandItems?.[0];

    const personaQuery =
      selectedOptionShow !== "Product"
        ? "customer_brand_persona"
        : "customer_brand_product_persona";

    // Combine and deduplicate llm_efr_ids
    const uniqueLlmEfrIds = [
      ...new Set([...indexScoreMeta.map((obj) => obj.llm_efr_id)]),
    ];

    if (uniqueLlmEfrIds.length === 0) {
      return { indexScoreMeta }; // Return early if no IDs
    }

    // Fetch efrData based on unique IDs
    const payload = { efr_ids: uniqueLlmEfrIds };
    const efrData = await getCustomerEfrLlm(payload);

    if (!efrData || efrData.length === 0) {
      return { indexScoreMeta }; // Return early if no data
    }

    // Create a lookup map for faster access
    const efrDataMap = efrData.reduce((map, item) => {
      map[item.id] = item;
      return map;
    }, {});

    // Map metadata with fetched data
    const mapWithEfrData = (metaArray) =>
      metaArray.map((obj) => ({
        extras:
          obj?.brand_index_json_response?.extras ||
          obj?.brand_index_json_response,
        name: obj?.name || currentBrandProduct,
        llm: efrDataMap[obj.llm_efr_id]?.customer_llm?.llm?.name,
        persona: efrDataMap[obj.llm_efr_id]?.[personaQuery]?.persona?.name,
        category: efrDataMap[obj.llm_efr_id]?.[personaQuery]?.category?.name,
        market: efrDataMap[obj.llm_efr_id]?.customer_llm?.market?.name,
        geography: efrDataMap[obj.llm_efr_id]?.customer_llm?.geography?.name,
        categoryName: obj?.category_name,
      }));

    setSecCategoryIndexScoreMetaData([...mapWithEfrData(indexScoreMeta)] || []);
  };

const getIndexScoreMetaData = async (result, processJsonResponse = false) => {
  let indexScoreMeta = result?.indeScoreMetaData || [];
  let compIndexScoreMeta = result?.compIndexScoreMetaData || [];
  if (processJsonResponse) {
    indexScoreMeta = filterRecentByBrandId(indexScoreMeta || []);
    compIndexScoreMeta = filterRecentByBrandId(compIndexScoreMeta || []);
    if (indexScoreMeta.length) {
      const jsonResponse = indexScoreMeta?.[0]?.json_response;
      indexScoreMeta = indexScoreMeta?.[0]?.brand_index_json_response;
      if (jsonResponse) {
        indexScoreMeta.extras = {
          ...indexScoreMeta.extras,
          ...result?.indeScoreMetaData[0].json_response.extras,
          llm_efr_id: result?.indeScoreMetaData?.[0]?.llm_efr_id,
        };
      } else {
        indexScoreMeta = {
          ...indexScoreMeta,
          llm_efr_id: result?.indeScoreMetaData?.[0]?.llm_efr_id,
        };
      }
      const firstItem = result?.indeScoreMetaData?.[0];

      indexScoreMeta = {
        ...indexScoreMeta,
        baseResponses:
          firstItem?.brand_index_json_response?.baseResponses ||
          firstItem?.reach_json_response?.baseResponses,
        completeBaseRes:
          firstItem?.brand_index_json_response?.completeBaseRes ||
          firstItem?.sentiment_json_response?.completeBaseRes
      };

      setIndexScoreMetaData(indexScoreMeta || {});
    }

    if (compIndexScoreMeta.length) {
      compIndexScoreMeta = compIndexScoreMeta.map((obj) => ({
        extras: {
          ...(obj?.brand_index_json_response?.extras ||
            obj?.brand_index_json_response ||
            {}),
          llm_efr_id: obj?.llm_efr_id,
          comp_brand_id: obj?.comp_brand_id,
          comp_brand_product_id: obj?.comp_brand_product_id,
          ...(!obj?.brand_index_json_response?.baseResponses && {
            baseResponses: obj?.reach_json_response?.baseResponses,
            completeBaseRes: obj?.sentiment_json_response?.completeBaseRes
          })
        },
        name: obj?.name,
      }));
      setCompIndexScoreMetaData(compIndexScoreMeta || []);
    }

    return; // Early return if processJsonResponse is true
  }

  const currentBrandProduct =
    selectedOptionShow === "Product"
      ? selectedProductItems?.[0]
      : selectedBrandItems?.[0];

  const personaQuery =
    selectedOptionShow !== "Product"
      ? "customer_brand_persona"
      : "customer_brand_product_persona";

  // Combine and deduplicate llm_efr_ids
  const uniqueLlmEfrIds = [
    ...new Set([
      ...indexScoreMeta.map((obj) => obj.llm_efr_id),
      ...compIndexScoreMeta.map((obj) => obj.llm_efr_id),
    ]),
  ];

  if (uniqueLlmEfrIds.length === 0) {
    return { indexScoreMeta, compIndexScoreMeta }; // Return early if no IDs
  }

  // Fetch efrData based on unique IDs
  const payload = { efr_ids: uniqueLlmEfrIds };
  const efrData = await getCustomerEfrLlm(payload);

  if (!efrData || efrData.length === 0) {
    return { indexScoreMeta, compIndexScoreMeta }; // Return early if no data
  }

  // Create a lookup map for faster access
  const efrDataMap = efrData.reduce((map, item) => {
    map[item.id] = item;
    return map;
  }, {});

  // Map metadata with fetched data
  const mapWithEfrData = (metaArray) =>
    metaArray.map((obj) => {
      const extras = obj?.brand_index_json_response?.extras || obj?.brand_index_json_response || {};
      
      return {
        extras: {
          ...extras,
          ...(!extras.baseResponses && {
            baseResponses: obj?.reach_json_response?.baseResponses,
            completeBaseRes: obj?.sentiment_json_response?.completeBaseRes
          })
        },
        name: obj?.name || currentBrandProduct,
        llm: efrDataMap[obj.llm_efr_id]?.customer_llm?.llm?.name,
        persona: efrDataMap[obj.llm_efr_id]?.[personaQuery]?.persona?.name,
        category: efrDataMap[obj.llm_efr_id]?.[personaQuery]?.category?.name,
        market: efrDataMap[obj.llm_efr_id]?.customer_llm?.market?.name,
        geography: efrDataMap[obj.llm_efr_id]?.customer_llm?.geography?.name,
      };
    });

  setIndexScoreMetaData(
    [
      ...mapWithEfrData(indexScoreMeta),
      ...mapWithEfrData(compIndexScoreMeta),
    ] || []
  );
};

  const updateCustomFilterState = (value) => {
    setCustomDateFilter(value);
  };

  function getUniqueSourceIds(...arrays) {
    const combinedArray = arrays.flat();
    const uniqueSourceIds = new Set(combinedArray.map((obj) => obj?.source_id));
    return Array.from(uniqueSourceIds);
  }

  const getSourcesInBrandOverview = async (result, attSources) => {
    // PN-Attributes

    let positiveAttSources = attSources?.cumulativeSourcesData?.filter(
      (item) => item?.is_positive
    );
    let negativeAttSources = attSources?.cumulativeSourcesData?.filter(
      (item) => !item?.is_positive
    );

    positiveAttSources = transformSourceData(positiveAttSources, "llm");
    negativeAttSources = transformSourceData(negativeAttSources, "llm");

    setLlmAttributesSources(positiveAttSources);
    setLlmNegativeAttributesSources(negativeAttSources);

    // Purchase criteria

    const categoryDimRatingSources = transformSourceData(
      result?.llmCategoryDimensionSources?.llmCategoryDimensionsRatingSource,
      "llm"
    );
    const categoryDimSources = transformSourceData(
      result?.llmCategoryDimensionSources?.llmCategoryDimensionsSource,
      "llm"
    );

    const categoryDimensionsSourceData = {
      sourceResult: categoryDimSources,
      ratingSourceResult: categoryDimRatingSources,
    };

    // brand-pillars

    let coreAttSources = transformSourceData(
      result?.llmCoreAttributesSource,
      "llm"
    );

    // reach
    let llmReachSources = transformSourceData(result?.llmReachSource, "llm");

    // sentiment

    let llmSentimentSource = transformSourceData(
      result?.llmSentimentSource,
      "llm"
    );

    setCategoryDimensionSourceData(categoryDimensionsSourceData?.sourceResult);
    setCategoryDimensionRatingSourceData(
      categoryDimensionsSourceData?.ratingSourceResult
    );
    setCoreAttSourceData(coreAttSources);
    setReachSourceData(llmReachSources);
    setSentimentSourceData(llmSentimentSource);

    setSourceURLIds([]);
    setSourceFullUrls([]);
  };

  const getSourceDashboardData = async (result, result2) => {
    const flagMappings = {
      CATEGORY: "category",
      PERSONA: "persona",
      LLM: "llm",
    };

    // PN-Attributes

    let positiveAttSources = result?.cumulativeSourcesData?.filter(
      (item) => item?.is_positive
    );
    let negativeAttSources = result?.cumulativeSourcesData?.filter(
      (item) => !item?.is_positive
    );

    positiveAttSources = transformSourceData(
      positiveAttSources,
      flagMappings[sourceFilter?.value] || "geography"
    );
    negativeAttSources = transformSourceData(
      negativeAttSources,
      flagMappings[sourceFilter?.value] || "geography"
    );

    setLlmAttributesSources(positiveAttSources);
    setLlmNegativeAttributesSources(negativeAttSources);

    // purchase criteria

    let llmCategoryDimensionsRatingSource = transformSourceData(
      result2?.llmCategoryDimensionSources?.llmCategoryDimensionsRatingSource,
      flagMappings[sourceFilter?.value] || "geography"
    );
    let llmCategoryDimensionsSource = transformSourceData(
      result2?.llmCategoryDimensionSources?.llmCategoryDimensionsSource,
      flagMappings[sourceFilter?.value] || "geography"
    );

    // brand-pillars

    let coreAttSources = transformSourceData(
      result2?.llmCoreAttributesSource,
      flagMappings[sourceFilter?.value] || "geography"
    );

    // reach

    let reachSources = transformSourceData(
      result2?.llmReachSource,
      flagMappings[sourceFilter?.value] || "geography"
    );

    // sentiment

    let sentimentSources = transformSourceData(
      result2?.llmSentimentSource,
      flagMappings[sourceFilter?.value] || "geography"
    );

    setSourceURLIds([]);
    setSourceAlias([]);

    setCategoryDimensionSourceData(llmCategoryDimensionsSource);
    setCategoryDimensionRatingSourceData(llmCategoryDimensionsRatingSource);
    setCoreAttSourceData(coreAttSources);
    setReachSourceData(reachSources);
    setSentimentSourceData(sentimentSources);
  };

  const getLlmComparisonData = async (brandId, productId, personaId, llmId) => {
    const customerLlmIds = getCustomerLlmInputIds();

    let result;
    let result2;

    if (selectedOptionShow === "Company/Brand") {
      const payload = {
        brandId: brandId,
        llmId: llmId,
        llmIds: customerLlmIds,
        personaIds: personaId,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
        categoryIds: selectedCategoryIds,
        startDate,
        endDate: customDateFilter === "Recent" ? endDate : startDate,
        isCompanyUser,
        customerId,
      };

      result = await getBrandAttributes(payload);
      result2 = await getCompMetricsForBrand(payload);
    } else {
      const payload = {
        productId: productId,
        llmId: llmId,
        llmIds: customerLlmIds,
        personaIds: personaId,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
        categoryType: activeTab,
        categoryIds: selectedCategoryIds,
        startDate,
        endDate: customDateFilter === "Recent" ? endDate : startDate,
        isCompanyUser,
        customerId,
      };

      result = await getProductAttributes(payload);
      result2 = await getCompMetricsForProduct(payload);
    }

    if (
      typeof result2?.indexScoreDataForChart === "object" &&
      result2?.indexScoreDataForChart !== null &&
      !Array.isArray(result2?.indexScoreDataForChart) &&
      Object.keys(result2?.indexScoreDataForChart).length > 0
    ) {
      const brandIndexChartArray = indexScoreChartData(
        result2?.indexScoreDataForChart,
        "avg_brand_index_score",
        undefined,
        undefined,
        selectedOptionShow,
        selectedProductItems,
        selectedBrandItems
      );

      setIndexScoreDataForChart(brandIndexChartArray);
    }
    await getSourceDashboardData(result, result2);
    await getIndexScoreMetaData(result2);
    await getSecCategoryIndexScoreMetaData(result2);
    setProductTaxonomyData(result2?.productTaxonomyData);
    getCategoryComparisonDataAndUpdateStates(result, result2);
  };

  const getSceondaryCategoryIndexScores = (result2) => {
    const {
      brandIndexFromFavAndRach,
      pastBrandIndexFromFavAndRach,
      currentBrandIndexScore,
      pastBrandIndexScore,
    } = getSecondaryCategoryIndexScoreData(
      result2,
      selectedBrandItems,
      selectedProductItems,
      value,
      selectedSubFrequencyItems,
      selectedOptionShow
    );

    const newLlmCompBrandFav = {};
    const newLlmCompBrandReach = {};
    const pastLlmCompBrandFav = {};
    const pastLlmCompBrandReach = {};

    Object.keys(currentBrandIndexScore || {}).forEach((categoryId) => {
      newLlmCompBrandFav[categoryId] = calculateAverageData(
        currentBrandIndexScore?.[categoryId]?.brandFavData
      )?.["avg"];
    });

    Object.keys(currentBrandIndexScore || {}).forEach((categoryId) => {
      newLlmCompBrandReach[categoryId] = calculateAverageData(
        currentBrandIndexScore?.[categoryId]?.brandReachData
      )?.["avg"];
    });

    Object.keys(pastBrandIndexScore || {}).forEach((categoryId) => {
      pastLlmCompBrandFav[categoryId] = calculateAverageData(
        pastBrandIndexScore?.[categoryId]?.brandFavData
      )?.["avg"];
    });

    Object.keys(pastBrandIndexScore || {}).forEach((categoryId) => {
      pastLlmCompBrandReach[categoryId] = calculateAverageData(
        pastBrandIndexScore?.[categoryId]?.brandReachData
      )?.["avg"];
    });

    const pastSecCategoryRbiScore = {
      indexScore: pastBrandIndexFromFavAndRach,
      fav: pastLlmCompBrandFav,
      rank: pastLlmCompBrandReach,
    };

    return {
      pastSecCategoryRbi: pastSecCategoryRbiScore,
      secCategoryBrandIndex: brandIndexFromFavAndRach,
      secCategorySentiment: newLlmCompBrandFav,
      secCategoryReach: newLlmCompBrandReach,
    };
  };

  const getCategoryComparisonDataAndUpdateStates = (result, result2) => {
    const {
      data,
      coreAttdata,
      pastCoreAttdata,
      categoryDimdata,
      pastCategoryDimdata,
      brandIndexFromFavAndRach,
      pastBrandIndexFromFavAndRach,
      selectedBrandCategory,
      selectedBrandProductCategory,
      currentBrandIndexScore,
      pastBrandIndexScore,
    } = getComparisonDashboardData(
      result,
      result2,
      selectedBrandItems,
      selectedProductItems,
      value,
      selectedSubFrequencyItems,
      selectedOptionShow,
      brands,
      brandProducts
    );

    const {
      pastSecCategoryRbi,
      secCategoryBrandIndex,
      secCategorySentiment,
      secCategoryReach,
    } = getSceondaryCategoryIndexScores(result2);

    setSecCategoryBrandReach(secCategoryReach);
    setSecCategoryBrandFav(secCategorySentiment);
    setSecCategoryBrandIndex(secCategoryBrandIndex);
    setPastSecCategoryBrandIndex(pastSecCategoryRbi);

    setLlmAttributes(
      calculateAverageData(data?.positiveAttributesStructuredData)?.["avg"]
    );
    setLlmNegativeAttributes(
      calculateAverageData(data?.negativeAttributesStructuredData)?.["avg"]
    );

    setLlmCompBrandIndex(brandIndexFromFavAndRach);
    setLlmCompBrandFav(
      calculateAverageData(currentBrandIndexScore?.brandFavData)?.["avg"]
    );
    setLlmCompBrandReach(
      calculateAverageData(currentBrandIndexScore?.brandReachData, true)?.[
      "avg"
      ]
    );

    setPastLlmCompBrandIndex({
      indexScore: pastBrandIndexFromFavAndRach,
      fav: calculateAverageData(pastBrandIndexScore?.brandFavData)?.["avg"],
      rank: calculateAverageData(pastBrandIndexScore?.brandReachData, true)?.[
        "avg"
      ],
    });

    setCompCoreAttributes(
      calculateAverageDataStructure(coreAttdata?.dateSeriesData)?.["avg"]
    );
    setPastCompCoreAttributes(
      calculateAverageDataStructure(pastCoreAttdata?.dateSeriesData)?.["avg"]
    );

    setCompCategoryDimensions(
      calculateAverageDataStructure(categoryDimdata?.dateSeriesData)?.["avg"]
    );
    setCompPastCategoryDimensions(
      calculateAverageDataStructure(pastCategoryDimdata?.dateSeriesData)?.[
      "avg"
      ]
    );
    setBrandCategory(selectedBrandCategory);
    setProductCategory(selectedBrandProductCategory);
  };

  const getCustomerLlmInputIds = () => {
    // Use pre-calculated IDs during initial load (before state updates)
    if (window.__initialCustomerLlmIds) {
      const ids = window.__initialCustomerLlmIds;
      delete window.__initialCustomerLlmIds; // Clear after first use
      return ids;
    }

    const llmIds = dbLlms
      .filter((item) => selectedLlmItems.includes(item?.name))
      .map((obj) => obj?.id);

    const marketIds = markets
      .filter((item) => selectedMarketItems.includes(item?.name))
      .map((obj) => obj?.id);

    const geoIds = geography
      .filter((item) => selectedGeographyItems.includes(item?.name))
      .map((obj) => obj?.id);

    const customerLlmIds = customerLlm
      .filter(
        (item) =>
          llmIds.includes(item?.llm_id) &&
          marketIds.includes(item?.market_id) &&
          geoIds.includes(item?.geography_id)
      )
      .map((obj) => obj?.id);

    return customerLlmIds;
  };

  const getCompetitorComparisonData = async (
    brandId,
    productId,
    personaId,
    llmId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds,
    categoryIds
  ) => {
    let result;
    let attributeSources;
    const customerLlmIds = getCustomerLlmInputIds();
    setSelectedInputIds({
      brandId,
      productId,
      personaId,
      llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
      categoryIds: selectedCategoryIds || categoryIds,
      isCompanyUser,
      customerId,
    });

    if (selectedOptionShow === "Company/Brand") {
      const payload = {
        brandId: brandId,
        llmId: llmId,
        brandIds: brandIds,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
        categoryIds: selectedCategoryIds || categoryIds,
        startDate,
        endDate: customDateFilter === "Recent" ? endDate : startDate,
        isCompanyUser,
        customerId,
      };
      attributeSources = await getBrandAttributes(payload);
      result = await getCompMetricsForBrand(payload);
    } else {
      const payload = {
        productId: productId,
        llmId: llmId,
        llmIds: customerLlmIds.length === 0 ? [llmId] : customerLlmIds,
        personaIds: personaId,
        productIds: productIds,
        frequency: selectedFrequencyItems[0],
        timePeriod: selectedSubFrequencyItems,
        categoryIds: selectedCategoryIds || categoryIds,
        startDate,
        endDate: customDateFilter === "Recent" ? endDate : startDate,
        isCompanyUser,
        customerId,
      };
      attributeSources = await getProductAttributes(payload);
      result = await getCompMetricsForProduct(payload);
    }

    setProductTaxonomyData(result?.productTaxonomyData);
    setSecondaryCategoryMetaData(result.secondaryCategoryMetaData);
    getCompetitorIndexScores(
      result,
      brandName,
      productName,
      result?.realPastDate
    );

    const {
      data,
      attributesData,
      pastCategoryDimData,
      categoryDimdata,
      remainingData,
      selectedBrandCategory,
      selectedBrandProductCategory,
    } = getCompetitorMetricData(
      result,
      selectedOptionShow,
      selectedBrandItems,
      selectedProductItems,
      brandName,
      productName,
      selectedSubFrequencyItems,
      brands,
      brandProducts
    );

    setCompCoreAttributes(calculateAverageDataStructure(data)?.["avg"]);

    setPastCompCoreAttributes(
      calculateAverageDataStructure(remainingData)?.["avg"]
    );

    setCompCategoryDimensions(
      calculateAverageDataStructure(categoryDimdata)?.["avg"]
    );
    setCompPastCategoryDimensions(
      calculateAverageDataStructure(pastCategoryDimData)?.["avg"]
    );

    setBrandCategory(selectedBrandCategory);
    setProductCategory(selectedBrandProductCategory);
    setCompPositiveAttributes(
      calculateAverageData(attributesData?.mergedData)?.["avg"]
    );
    setCompNegativeAttributes(
      calculateAverageData(attributesData?.negativeAttributesMergedData)?.[
      "avg"
      ]
    );
    await getIndexScoreMetaData(result, true);
    await getSourcesInBrandOverview(result, attributeSources);
    if (value === 0) {
      const { attDataForGraph, pastAttDataForGraph } =
        getBrandProductOverviewData(
          result,
          selectedOptionShow,
          value,
          selectedSubFrequencyItems,
          selectedProductItems
        );

      setPositiveAttGraphData(
        attDataForGraph?.positiveAttResult?.slice(0, 8) || []
      );
      setNegativeAttGraphData(
        attDataForGraph?.negativeAttResult?.slice(0, 8) || []
      );
      setPastPositiveAttGraphData(
        pastAttDataForGraph?.positiveAttResult?.slice(0, 8) || []
      );
      setPastNegativeAttGraphData(
        pastAttDataForGraph?.negativeAttResult?.slice(0, 8) || []
      );
    }
  };

  const NoDataFound = () => {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "#555" }}>
        <h3>No Data</h3>
        <p>
          Please fill in the valid input to get monitoring and analysis data.
        </p>
      </div>
    );
  };

  const getLlmComparisonDashboardDataFromDB = async (
    brandId,
    productId,
    llmId,
    personaId,
    isInitial
  ) => {
    setShowData(false);
    setIsDone(false);

    try {
      await getLlmComparisonData(
        brandId,
        productId,
        personaId,
        llmId,
        isInitial
      );

      setShowData(true);
      setIsDone(true);
    } catch (err) {
      setIsDone(true);
    }
  };

  const getCompDashboardDataFromDB = async (
    brandId,
    productId,
    llmId,
    personaId,
    isInitial,
    brandName,
    productName,
    categoryName,
    brandIds,
    productIds,
    categoryIds,
    isMetaRefresh
  ) => {
    if (isMetaRefresh) {
      await getCompetitorComparisonData(
        brandId,
        productId,
        personaId,
        llmId,
        isInitial,
        brandName,
        productName,
        categoryName,
        brandIds,
        productIds,
        categoryIds
      );
      return;
    }

    setShowData(false);
    setIsDone(false);

    try {
      await getCompetitorComparisonData(
        brandId,
        productId,
        personaId,
        llmId,
        isInitial,
        brandName,
        productName,
        categoryName,
        brandIds,
        productIds,
        categoryIds
      );

      setShowData(true);
      setIsDone(true);
    } catch (err) {
      setIsDone(true);
    }
  };

  const fetchRealTimeActionsSources = async (attName, metric) => {
    try {
      if (!selectedInputIds || !selectedOptionShow) return;

      const { brandId, productId, personaId, llmIds } = selectedInputIds;

      const payload = {
        personaIds: personaId,
        llmIds,
        ...(selectedOptionShow === "Product" ? { productId } : { brandId }),
        timePeriod: selectedSubFrequencyItems,
        attName,
        metric,
        startDate,
        endDate,
      };

      const { sources } = await getRealtimeActionsSource(payload);

      return sources;
    } catch (err) {
      console.error("Error fetching actions:", err);
    }
  };

  function handleFilterMenuSelect(type) {
    if (type === "reset") {
      const {
        brandItems,
        LlmItems,
        persona,
        geographyItems,
        frequencyItems,
        marketItems,
      } = initialConfig;
      setSelectedBrandItems(brandItems);
      setSelectedLlmItems(LlmItems);
      setSelectedPersona(persona);
      setSelectedGeographyItems(geographyItems);
      setSelectedSubFrequencyItems(frequencyItems);
      setSelectedMarketItems(selectedMarketItems);
      setIsFilterActive(false);
      return;
    }
    setFilterModalType(type);
    setShowFilterModal(true);
  }

  function handleFilterItemSelect(item) {
    if (!isFilterActive) {
      setInitialConfig({
        brandItems: selectedBrandItems,
        LlmItems: selectedLlmItems,
        persona: selectedPersona,
        geographyItems: selectedGeographyItems,
        frequencyItems: selectedSubFrequencyItems,
        marketItems: selectedMarketItems,
      });
    }

    const {
      selectedLlmItems: llm,
      selectedBrandItems: brand,
      selectedPersona: persona,
      selectedGeographyItems: geo,
      selectedFrequencyItems: freq,
      selectedMarketItems: market,
    } = item.config;

    selectedOptionShow !== "Product" &&
      handleBrandCheckChange([{ brand: { name: brand[0] } }]);
    setShowFilterModal(false);
    setSelectedBrandItems(brand);
    setSelectedLlmItems(llm);
    setSelectedPersona(persona);
    setSelectedGeographyItems(geo);
    setSelectedSubFrequencyItems(freq);
    setSelectedMarketItems(market);
    setIsFilterQuery(true);
    setIsFilterActive(true);
  }

  useRegisterTabContext(
    "brand-monitoring",
    {
      execution_date: customDatesToDisplay?.endDate,
      brand: selectedBrandItems[0],
      brandContext: "monitoring",
      category: selectedCategory[0],
      llmModel: selectedLlmItems[0],
      customData: {
        dashboardType: "brand",
        view: "analysis",
      },
    },
    {
      clearOnUnmount: false,
      dependencies: [customDatesToDisplay, selectedBrandItems, selectedCategory, selectedLlmItems]
    }
  );

  if (
    selectedOptionShow === "Product" &&
    monitoringFiletrs?.products &&
    !monitoringFiletrs?.products?.length
  ) {
    return <EmptyView message="No Products Found" />;
  }
  console.log(
    "selectedBrandItems",
    selectedBrandItems,
    selectedProductItems,
    selectedCategory,
    selectedPersona,
    selectedGeographyItems,
    selectedMarketItems,
    selectedLlmItems,
    availableDates,
    endDate,
    startDate,

  );
  return (
    <div className="bodycontent">
      <div>
        <DashboardNav
          setCustomDatesToDisplay={setCustomDatesToDisplay}
          availableDates={availableDates}
          endDate={endDate}
          setEndDate={setEndDate}
          startDate={startDate}
          setStartDate={setStartDate}
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          selectedOptionShow={selectedOptionShow}
          brandItems={brandItems}
          brandCategories={categories || []}
          selectedBrandItems={selectedBrandItems}
          handleBrandCheckChange={handleBrandCheckChange}
          handleProductCheckChange={handleProductCheckChange}
          selectedProductItems={selectedProductItems}
          productItems={productItems}
          inputValidation={inputValidation}
          isFirstTime={isFirstTime}
          selectedPersona={selectedPersona}
          handlePersonaCheckChange={handlePersonaCheckChange}
          handleCategoryCheckChange={handleCategoryCheckChange}
          selectedCategory={selectedCategory}
          personas={personas}
          categories={categories}
          selectedGeographyItems={selectedGeographyItems}
          handleGeographyCheckChange={handleGeographyCheckChange}
          geography={geography}
          selectedMarketItems={selectedMarketItems}
          handleMarketCheckChange={handleMarketCheckChange}
          markets={markets}
          selectedLlmItems={selectedLlmItems}
          selectedLlmProviders={selectedLlmProviders}
          handleLlmCheckChange={handleLlmCheckChange}
          dbLlms={dbLlms}
          selectedSubFrequencyItems={selectedSubFrequencyItems}
          handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
          showData={showData}
          isDone={isDone}
          handleClickShow={handleClickShow}
          showFilterModal={showFilterModal}
          filterModalType={filterModalType}
          setShowFilterModal={setShowFilterModal}
          handleFilterItemSelect={handleFilterItemSelect}
          handleFilterMenuSelect={handleFilterMenuSelect}
          isFilterActive={true}
          sourceFilter={sourceFilter}
        />
      </div>
      <p> </p>
      <div>
        {!isFirstTime &&
          ((selectedOptionShow === "Product"
            ? !inputValidation.selectedProductItems
            : !inputValidation.selectedBrandItems) ||
            !inputValidation.selectedPersona ||
            !inputValidation.selectedGeographyItems ||
            !inputValidation.selectedMarketItems ||
            !inputValidation.selectedCategory ||
            !inputValidation.selectedLlmItems) &&
          NoDataFound()}

        {shouldShowLoader() && (
          <div
            style={{
              fontSize: "19px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              color: "green",
            }}
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Please Wait...
          </div>
        )}

        {showData &&
          isDone &&
          (selectedOptionShow === "Product"
            ? inputValidation.selectedProductItems
            : inputValidation.selectedBrandItems) &&
          inputValidation.selectedPersona &&
          inputValidation.selectedGeographyItems &&
          inputValidation.selectedMarketItems &&
          inputValidation.selectedCategory &&
          inputValidation.selectedLlmItems && (
            <>
              {activeTab === "overview" && (
                <BrandProductOverview
                  customDatesToDisplay={customDatesToDisplay}
                  handleClickShow={handleClickShow}
                  activeTarget={customDateFilter}
                  updateCustomFilterState={updateCustomFilterState}
                  startDate={startDate}
                  endDate={endDate}
                  fetchRealTimeActionsSources={fetchRealTimeActionsSources}
                  sourceURLIds={sourceURLIds}
                  selectedInputIds={selectedInputIds}
                  selectedInput={{
                    llm: selectedLlmItems?.[0],
                    market: selectedMarketItems?.[0],
                    persona: selectedPersona?.[0],
                    brand: selectedBrandItems?.[0],
                    product: selectedProductItems?.[0],
                    geography: selectedGeographyItems?.[0],
                    category: selectedCategory?.[0],
                  }}
                  productTaxonomyData={productTaxonomyData}
                  sourceFullUrls={sourceFullUrls}
                  indexScoreMetaData={indexScoreMetaData}
                  compIndexScoreMetaData={compIndexScoreMetaData}
                  domain={
                    selectedOptionShow == "Product"
                      ? brandProductDomains[selectedProductItems?.[0]]
                      : brandDomains[selectedBrandItems?.[0]]
                  }
                  brandProductInfo={
                    selectedOptionShow == "Product"
                      ? brandProductInfoJson[selectedProductItems?.[0]]
                      : brandInfoJson[selectedBrandItems?.[0]]
                  }
                  brandProduct={
                    selectedOptionShow == "Product"
                      ? selectedProductItems?.[0]
                      : selectedBrandItems?.[0]
                  }
                  type={selectedOptionShow}
                  brandProductCategory={
                    // selectedOptionShow == "Product"
                    //   ? productCategory
                    //   : brandCategory

                    selectedCategory
                  }
                  indexScoreDataForLineChart={indexScoreDataForChart}
                  compCoreAttributes={compCoreAttributes}
                  compCategoryDimensions={compCategoryDimensions}
                  brandDomains={
                    selectedOptionShow == "Product"
                      ? brandProductDomains
                      : brandDomains
                  }
                  positiveAttGraphData={positiveAttGraphData}
                  negativeAttGraphData={negativeAttGraphData}
                  pastPositiveAttGraphData={pastPositiveAttGraphData}
                  pastNegativeAttGraphData={pastNegativeAttGraphData}
                  compBrandIndexScore={avgBrandIndex}
                  pastCompBrandIndexScore={avgPastBrandIndex}
                  pastCompCoreAttributes={pastCompCoreAttributes}
                  pastCompCategoryDimensions={pastCompCategoryDimensions}
                  categoryDimensionSource={categoryDimensionSourceData}
                  categoryDimensionRatingSource={
                    categoryDimensionRatingSourceData
                  }
                  coreAttSourceData={coreAttSourceData}
                  reachSourceData={reachSourceData}
                  sentimentSourceData={sentimentSourceData}
                  positiveAttSource={llmAttributesSources}
                  negativeAttSource={llmNegativeAttributesSources}
                  frequency={selectedSubFrequencyItems}
                  secondaryCategoryMetaData={secondaryCategoryMetaData}
                />
              )}

              {activeTab === "competition" && (
                <CompComparisonComponent
                  customDatesToDisplay={customDatesToDisplay}
                  indexScoreDataForLineChart={indexScoreDataForChart}
                  startDate={startDate}
                  endDate={endDate}
                  activeTarget={customDateFilter}
                  updateCustomFilterState={updateCustomFilterState}
                  fetchRealTimeActionsSources={fetchRealTimeActionsSources}
                  sourceURLIds={sourceURLIds}
                  categoryDimensionRatingSource={
                    categoryDimensionRatingSourceData
                  }
                  brandProductCategory={
                    // selectedOptionShow === "Product"
                    //   ? productCategory
                    //   : brandCategory
                    selectedCategory
                  }
                  coreAttSourceData={coreAttSourceData}
                  reachSourceData={reachSourceData}
                  sentimentSourceData={sentimentSourceData}
                  positiveAttSource={llmAttributesSources}
                  negativeAttSource={llmNegativeAttributesSources}
                  customerId={customerId}
                  selectedInput={{
                    llm: selectedLlmItems?.[0],
                    market: selectedMarketItems?.[0],
                    persona: selectedPersona?.[0],
                    brand: selectedBrandItems?.[0],
                    product: selectedProductItems?.[0],
                    geography: selectedGeographyItems?.[0],
                    category: selectedCategory?.[0],
                  }}
                  productTaxonomyData={productTaxonomyData}
                  indexScoreMetaData={indexScoreMetaData}
                  compIndexScoreMetaData={compIndexScoreMetaData}
                  compCoreAttributes={compCoreAttributes}
                  pastCompCoreAttributes={pastCompCoreAttributes}
                  compCategoryDimensions={compCategoryDimensions}
                  pastCompCategoryDimensions={pastCompCategoryDimensions}
                  compBrandIndexScore={avgBrandIndex}
                  pastCompBrandIndexScore={avgPastBrandIndex}
                  compPositiveAttributes={compPositiveAttributes}
                  compNegativeAttributes={compNegativeAttributes}
                  brandDomains={
                    selectedOptionShow == "Product"
                      ? brandProductDomains
                      : brandDomains
                  }
                  secondaryCategoryMetaData={secondaryCategoryMetaData}
                  brandProduct={
                    selectedOptionShow == "Product"
                      ? selectedProductItems?.[0]
                      : selectedBrandItems?.[0]
                  }
                  type={selectedOptionShow}
                  frequency={selectedSubFrequencyItems}
                />
              )}

              {activeTab === "sources" && (
                <SourceComponent
                  startDate={startDate}
                  endDate={endDate}
                  indexScoreDataForLineChart={indexScoreDataForChart}
                  customDatesToDisplay={customDatesToDisplay}
                  frequency={selectedSubFrequencyItems}
                  activeTarget={customDateFilter}
                  updateCustomFilterState={updateCustomFilterState}
                  sourceAlias={sourceAlias}
                  sourceFilter={sourceFilter}
                  handleFilterChange={handleFilterChange}
                  positiveAttSource={llmAttributesSources}
                  negativeAttSource={llmNegativeAttributesSources}
                  categoryDimensionSource={categoryDimensionSourceData}
                  categoryDimensionRatingSource={
                    categoryDimensionRatingSourceData
                  }
                  coreAttSourceData={coreAttSourceData}
                  reachSourceData={reachSourceData}
                  sentimentSourceData={sentimentSourceData}
                  isProductDashboard={selectedOptionShow == "Product"}
                  brandProduct={
                    selectedOptionShow == "Product"
                      ? selectedProductItems?.[0]
                      : selectedBrandItems?.[0]
                  }
                  selectedInput={{
                    llm: selectedLlmItems?.[0],
                    market: selectedMarketItems?.[0],
                    persona: selectedPersona?.[0],
                    brand: selectedBrandItems?.[0],
                    product: selectedProductItems?.[0],
                    geography: selectedGeographyItems?.[0],
                    category: selectedCategory?.[0],
                  }}
                />
              )}
              {activeTab !== "overview" &&
                activeTab !== "competition" &&
                activeTab !== "sources" && (
                  <MultiComparisonComponent
                    customDatesToDisplay={customDatesToDisplay}
                    indexScoreDataForLineChart={indexScoreDataForChart}
                    startDate={startDate}
                    endDate={endDate}
                    activeTab={activeTab}
                    llmsData={dbLlms}
                    activeTarget={customDateFilter}
                    updateCustomFilterState={updateCustomFilterState}
                    fetchRealTimeActionsSources={fetchRealTimeActionsSources}
                    sourceURLIds={sourceURLIds}
                    reachSourceData={reachSourceData}
                    sentimentSourceData={sentimentSourceData}
                    categoryDimensionRatingSource={
                      categoryDimensionRatingSourceData
                    }
                    secCategoryIndexScoreMetaData={
                      secCategoryIndexScoreMetaData
                    }
                    coreAttSourceData={coreAttSourceData}
                    positiveAttSource={llmAttributesSources}
                    negativeAttSource={llmNegativeAttributesSources}
                    customerId={customerId}
                    selectedInput={{
                      llm: selectedLlmItems?.[0],
                      market: selectedMarketItems?.[0],
                      persona: selectedPersona?.[0],
                      brand: selectedBrandItems?.[0],
                      product: selectedProductItems?.[0],
                      geography: selectedGeographyItems?.[0],
                      category: selectedCategory?.[0],
                    }}
                    productTaxonomyData={productTaxonomyData}
                    indexScoreMetaData={indexScoreMetaData}
                    compCoreAttributes={compCoreAttributes}
                    pastCompCoreAttributes={pastCompCoreAttributes}
                    compCategoryDimensions={compCategoryDimensions}
                    pastCompCategoryDimensions={pastCompCategoryDimensions}
                    brandIndex={llmCompBrandIndex}
                    brandReach={llmCompBrandReach}
                    brandFav={llmCompBrandFav}
                    pastIndexScoreObj={pastLlmCompBrandIndex}
                    secCategoryBrandFav={secCategoryBrandFav}
                    secCategoryReach={secCategoryBrandReach}
                    secCategoryBrandIndex={secCategoryBrandIndex}
                    pastsecCategoryBrandIndex={pastsecCategoryBrandIndex}
                    positiveAttributes={llmAttributes}
                    negativeAttributes={llmNegativeAttributes}
                    llmDomains={llmDomains}
                    geoLogo={geoLogo}
                    brandDomains={
                      selectedOptionShow == "Product"
                        ? brandProductDomains
                        : brandDomains
                    }
                    brandProduct={
                      selectedOptionShow == "Product"
                        ? selectedProductItems?.[0]
                        : selectedBrandItems?.[0]
                    }
                    type={selectedOptionShow}
                    brandProductCategory={selectedCategory}
                    frequency={selectedSubFrequencyItems}
                  />
                )}
            </>
          )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default Dashboard;
